export default __webpack_public_path__ + "static/illustration-business.url-4c255cbb8eef2bf0729764153bd6486b.svg";